export enum Language {
  EN = 'en',
  ES = 'es',
}

export interface ContentMetadata {
  title: Record<Language, string>;
  description?: Record<Language, string>;
  slug: Record<Language, string>;
  author?: string;
  thumbnail?: string;
  tags?: Record<Language, string[]>;
  featured?: boolean;
  datePublished?: string;
  dateModified?: string;
}

export interface ContentTranslation {
  language: string;
  content: string;
  excerpt?: string;
  isActive: boolean;
}

export interface ContentSEO {
  metaTitle?: Record<Language, string>;
  metaDescription?: Record<Language, string>;
  canonicalUrl?: Record<Language, string>;
  ogImage?: string;
  ogType?: string;
  keywords?: Record<Language, string[]>;
  schema?: Record<Language, any>;
}

export interface Content {
  _id: string;
  type: 'blog' | 'document';
  status: 'draft' | 'published' | 'archived';
  metadata: ContentMetadata;
  translations: ContentTranslation[];
  seo?: ContentSEO;
}

export interface ContentListResult {
  contents: Content[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface CreateContentInput {
  type: 'blog' | 'document';
  status: 'draft' | 'published' | 'archived';
  metadata: {
    title: Record<Language, string>;
    description: Record<Language, string>;
    slug: Record<Language, string>;
    author: string;
    thumbnail: string;
    tags: Record<Language, string[]>;
    featured: boolean;
    datePublished?: string;
    dateModified?: string;
  };
  translations: {
    language: string;
    content: string;
    excerpt?: string;
    isActive: boolean;
  }[];
  seo: {
    metaTitle: Record<Language, string>;
    metaDescription: Record<Language, string>;
    canonicalUrl: Record<Language, string>;
    ogImage: string;
    ogType: string;
    keywords: Record<Language, string[]>;
    schema: Record<Language, any>;
  };
}

export interface ContentFormData {
  type: 'blog' | 'document';
  title: Record<Language, string>;
  description: Record<Language, string>;
  content: Record<Language, string>;
  slug: Record<Language, string>;
  author: string;
  thumbnail: string;
  tags: Record<Language, string[]>;
  featured: boolean;
  status: 'draft' | 'published' | 'archived';
  seo: {
    metaTitle: Record<Language, string>;
    metaDescription: Record<Language, string>;
    canonicalUrl: Record<Language, string>;
    ogImage: string;
    ogType: string;
    keywords: Record<Language, string[]>;
    schema: Record<Language, any>;
  };
}
